<script>
export default {
  methods: {
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      })
    },
    getName() {
      return this.$auth?.user?.profile?.meta.name || this?.$auth?.user?.name
    },
  },
}
</script>

<template>
  <div v-if="$auth.isAuthenticated" class="signout">
    <div>
      <div>
        <a-avatar :src="this.$auth.user.picture" />
      </div>
      <span id="name">{{ getName() }}</span>
      <a-button type="ghost" @click="logout"><a-icon type="logout" /></a-button>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';
.signout {
  padding: 16px;
  color: white;
  background: #141414;
  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    #name {
      margin-left: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span {
      &:first-of-type {
        margin-right: 0;
        margin-left: 0;
      }
      &:last-of-type {
        margin-right: 0;
      }

      margin: 0 auto;
    }
    button {
      border: 0;
    }
  }
  @media screen and (max-height: 700px) {
    display: none;
  }
}
</style>
